import { render } from "./PaymentPriority.vue?vue&type=template&id=871c7caa&scoped=true"
import script from "./PaymentPriority.vue?vue&type=script&lang=js"
export * from "./PaymentPriority.vue?vue&type=script&lang=js"

import "./PaymentPriority.vue?vue&type=style&index=0&id=871c7caa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-871c7caa"]])

export default __exports__